// extracted by mini-css-extract-plugin
export default {"section":"Tabs_section__cQoQW","tabs":"Tabs_tabs__EX9St","tab":"Tabs_tab__5SI1p","tabActive":"Tabs_tabActive__90r7t","btn":"Tabs_btn__P8pEw","loading":"Tabs_loading__nrwcG"};